/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type ReverseOrder = {
    type: ReverseOrder.type;
    maxId: number;
};
export namespace ReverseOrder {
    export enum type {
        REVERSE = 'reverse',
    }
}

